var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_indicator_bullet"},[_c('span',{class:{'active' : _vm.pageNumberIndicator == 1},style:({
        'background': _vm.colors.theme == 'dark' ? '#fff' : '#000'
    })}),_c('span',{class:{'active' : _vm.pageNumberIndicator == 2},style:({
        'background': _vm.colors.theme == 'dark' ? '#fff' : '#000'
    })}),_c('span',{class:{'active' : _vm.pageNumberIndicator == 3},style:({
        'background': _vm.colors.theme == 'dark' ? '#fff' : '#000'
    })}),_c('span',{class:{'active' : _vm.pageNumberIndicator == 4},style:({
        'background': _vm.colors.theme == 'dark' ? '#fff' : '#000'
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }